import request from '@/utils/request'

export const getEmailCode = params =>
  request.post('/masterdata-api/forgetpassword/forget/email', params)

export const updatePassword = params =>
  request.post('/masterdata-api/forgetpassword/forget/modify', params)
// /forgetpassword/forget/email/check
export const checkCode = params =>
  request.post('/masterdata-api/forgetpassword/forget/email/check', params)
